<template>
    <div style="width: 100%;">
        <div class="hermanosVinculados pb-2 scrollbar" id="scrollbar-custom">
            <div class="divisionLHermanos tarjetaHermanos" v-for="(vin, i) in hermanos" :key="i">
                <md-menu md-align-trigger  md-size="auto" mdCloseOnClick>
                    <div md-menu-trigger class="d-flex align-items-center">
                        <div class="avatarAlumno">
                            <img :src="'/api/personas/' + vin.persona_id + '/avatar'" :alt="'Fotografía: '+ vin.apellido_paterno + vin.apellido_materno + vin.nombres">
                        </div>
                        <div class="colorNombreSeleccionado  pl-2">
                            <p class="mb-0 text-uppercase"><strong>{{vin.apellido_paterno}}  {{vin.apellido_materno}} {{vin.nombres}}</strong></p>
                            <p class="mb-0 text-uppercase">{{vin.matricula}}</p>
                        </div>
                        <div v-if="vin.programas[0]">
                                <i class="fas fa-caret-down" style="color: black"></i> 
                        </div>
                    </div>
                    <md-menu-content v-if="vin.programas[0]">
                        <div v-for="(prom, j) in vin.programas" :key="j" class="opcionesMenu" @click="getAlumnoClick(prom, vin)">
                            <p class="mb-0" style="font-weight: 500;">{{prom.institucion}} {{prom.institucion_id}}</p>
                            <i class="mb-0"><small>PROGRAMA</small></i>
                            <p class="mb-0" style="font-weight: 500;">{{prom.programa}}</p>
                            <i class="mb-0"><small>GRADO</small></i>
                            <p class="mb-0" style="font-weight: 500;">{{prom.grado}}</p>
                        </div>
                    </md-menu-content>
                </md-menu>
            </div>
        </div>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol',
        'personaId'
    ],
    data(){
        return{
            hermanos: [],
            nameStudent: '',
        }
    },
    created(){
        this.getHermanos()
    },
    methods:{
        async getHermanos(){
            try{
                const alumno = {}
                alumno.user_id = JSON.parse(this.personaRol).id
                const {data: response} = await alumnos.gethijosConPrograma(alumno)
                this.hermanos = response
                this.getNameStudent()
            }catch(error){
                console.error(error)

            }
            
        },
        getNameStudent(){
            const vm = this
            vm.hermanos.forEach(student => {
                if(student.persona_id == vm.personaId){
                    this.nameStudent = student.apellido_paterno + ' ' + student.apellido_materno + ' ' + student.nombres
                }
            })
            this.$emit('alumnoName', this.nameStudent);
        },
        getAlumnoClick(programa, user){
            this.$emit('studentClicked', user, programa);
        },

    },
}
</script>

<style lang="scss" scoped>
    @mixin phone {
    @media only screen and (min-width: 320px) {
        @content;
    }
    }
    @mixin tablet {
    @media only screen and (min-width: 769px) {
        @content;
    }
    }

    @mixin desktop {
    @media only screen and (min-width: 1240px) {
        @content;
    }
    }
    .hermanosVinculados{
        width: 100%;
        display: inline-flex;
        overflow: auto;
        .divisionLHermanos:not(:last-child){
            border-right: 1px solid black; 
        }
        .divisionLHermanos{
            padding: 0 1rem;
            align-items: center;
        }
        .avatarAlumno{
            border-radius: 50%;
        }
        .avatarAlumno img{
            max-width: none !important;
            width: 49px;
            height: 49px;
            border-radius: 50%;
	        object-fit: cover;
        }
        .colorNombreSeleccionado p{
            color: black;
        }
        .programasOpciones{
            word-wrap: break-word;
        }
        .tarjetaHermanos{
            min-width: 55% !important;
        }

        @include tablet(){
            .tarjetaHermanos{
                min-width: 20% !important;
            }
        }
        
    }
</style>
<style scoped>
.md-menu-content{
    max-width: 100% !important;
    border-radius: 5px 10px 10px 5px;
}
.md-menu-content-container{
    overflow: inherit !important;
    border-radius: 10px !important;
}
.opcionesMenu{
    padding: 10px;
    cursor: pointer;
}

.opcionesMenu:not(:last-child){
    border-bottom: 1px solid #E0E0E0;
}

.disabledOpcion p, .disabledOpcion i{
    color: #d8d8d8 !important;
    cursor: none !important;
}

</style>

<style>
.md-list.md-theme-default{
    border-radius: 5px 15px 15px 15px;
}
    
    /* customize scrollbar css */
    #scrollbar-custom::-webkit-scrollbar{
        width:7px;
        background-color:#ffffff;
    }
    #scrollbar-custom::-webkit-scrollbar:horizontal{
        height:7px;
    }
    #scrollbar-custom::-webkit-scrollbar-track{
        border:1px #ffffff solid;
        border-radius:10px;
    }
    #scrollbar-custom::-webkit-scrollbar-thumb{
        background-color:#d8d8d8;
        border:1px solid #ffffff;
        border-radius:16px;
    }
</style>